/**
 * Extension flow: DB seed via GET /api/extensions/seed/:policyNo
 * Must match server error codes EXTENSION_SEED_NOT_FOUND | EXTENSION_SEED_INCOMPLETE
 */

export const EXTENSION_SEED_USER_MESSAGE =
  'We could not load insured and vehicle details for this policy from our records. This transaction was not initiated from the Agent New Portal, or the policy data is not available here. Please contact Underwriting or complete the extension using the old portal.';

export function isUsableExtensionSeedPayload(data) {
  if (!data || !data.insuredData || !data.vehicleData) return false;
  const id = String(data.insuredData.idNumber || '').trim();
  const name = String(
    data.insuredData.insuredName || data.insuredData.insuredNameFull || ''
  ).trim();
  const reg = String(data.vehicleData.registrationNumber || '').trim();
  return !!(id && name && reg);
}

/**
 * @param {string} getApiUrl - (path) => full URL
 * @param {string} policyNo
 * @returns {Promise<{ success: boolean, clientId?: string, policyNo?: string, firstSegmentVehicleClass?: string|null, insuredData: object, vehicleData: object }>}
 */
export function extensionSeedApiPath(policyNo) {
  const key = String(policyNo || '').trim().replace(/\.+$/, '');
  return `/api/extensions/seed?policyNo=${encodeURIComponent(key)}`;
}

export async function fetchExtensionSeed(getApiUrl, policyNo) {
  const res = await fetch(getApiUrl(extensionSeedApiPath(policyNo)));
  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.userMessage || EXTENSION_SEED_USER_MESSAGE);
    err.code = data.code || (res.status === 404 ? 'EXTENSION_SEED_NOT_FOUND' : 'EXTENSION_SEED_ERROR');
    err.status = res.status;
    err.details = data;
    throw err;
  }
  if (!data.success || !isUsableExtensionSeedPayload(data)) {
    const err = new Error(data.userMessage || EXTENSION_SEED_USER_MESSAGE);
    err.code = 'EXTENSION_SEED_INCOMPLETE';
    throw err;
  }
  return data;
}
